import {useTranslation} from 'react-i18next'
import {CREATIVE_PLACEMENTS, type CreativePlacementId} from '../../../common/constants/creativeAssetSpecs'

interface PlacementTabsProps {
  value: CreativePlacementId
  onChange: (id: CreativePlacementId) => void
  /** Restrict the tabs (video mode has no Universal) */
  allowed?: readonly CreativePlacementId[]
}

const PlacementTabs = ({value, onChange, allowed}: PlacementTabsProps) => {
  const {t} = useTranslation()
  return (
    <div className="caa-tabs" role="tablist">
      {CREATIVE_PLACEMENTS.filter((spec) => !allowed || allowed.includes(spec.id)).map((spec) => (
        <button
          key={spec.id}
          type="button"
          role="tab"
          aria-selected={value === spec.id}
          className={`caa-tab${value === spec.id ? ' is-active' : ''}`}
          onClick={() => onChange(spec.id)}
        >
          <span>{t(`creativeAssets.placements.${spec.id}`)}</span>
          <span className="caa-tab-size">
            {spec.width} × {spec.height}
          </span>
        </button>
      ))}
    </div>
  )
}

export default PlacementTabs
